<div class="survey" [ngStyle]="{ width: '100%'}">
  <img class="survey-icon" src="../../../assets/survey.svg" alt="survey icon image">
  <span class="bold-title">SEND US YOUR FEEDBACK!</span>
  <span class="light-text">Found  a bug? <br>Something not working <br>like you expected? <br>Let us know and we'll<br>take a look!</span>
  <button class="btn survey-button" (click)="redirectToSurvey()">Give Feedback</button>
</div>
